import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["selector", "editorContainer", "editor"];

  connect() {
    this.updateEditorVisibility();
  }

  handleSelectionChange() {
    const selectedValue = this.selectorTarget.value;

    this.updateEditorVisibility();

    if (selectedValue === 'custom' || selectedValue === '') {
      this.clearEditor();
    } else {
      this.updateEditorContent(selectedValue);
    }
  }

  updateEditorVisibility() {
    const selectedValue = this.selectorTarget.value;

    this.editorContainerTarget.classList.toggle('d-none', selectedValue !== 'custom');
  }

  updateEditorContent(content) {
    const editorController = this.application.getControllerForElementAndIdentifier(this.editorTarget, 'bo-editor');

    if (editorController) {
      const editorData = {
        time: Date.now(),
        version: "2.19.1",
        blocks: [
          {
            type: "text",
            data: {
              text: content
            }
          }
        ]
      };
      editorController.editor.render(editorData);
    }
  }

  clearEditor() {
    const editorController = this.application.getControllerForElementAndIdentifier(this.editorTarget, 'bo-editor');
    editorController.editor.clear();
  }
}